import { render, staticRenderFns } from "./CreateCurve.vue?vue&type=template&id=6dd7d45b"
import script from "./CreateCurve.vue?vue&type=script&lang=ts"
export * from "./CreateCurve.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports